import firebase from 'firebase/app'
import 'firebase/firestore'
import { FirebaseCommon } from './FirebaseCommon'
import Vue from 'vue'
// import { ProductId } from "./Const"

// import { APIConnect } from "./APIConnect"
// import { Common } from "./common"
// import { SaleProductData } from "./SaleProductData"
// import config from 'config'

export default class DraftManager {
    constructor() {
      this.draftList = []
      this.designHistory = []
      this.selectDesign = null;
    }
    async update() {
      this.draftList = []
      this.designHistory = []
      await this.getFBDesignData();
      // console.log(this.draftList);
      // console.log(this.designHistory);
      Vue.set(this.draftList);
      Vue.set(this.designHistory);
    }

    selectDesign(designId){
      this.draftList.forEach(element => {
        if( element.designId == designId ){
          this.selectDesign = element;
        }
      });

      this.designHistory.forEach(element => {
        if( element.designId == designId ){
          this.selectDesign = element;
        }
      });
    }

    async deleteAll(){
      await this.allDeleteFBCartData()
    }

    async delete( designId ) {
      await this.deleteFBCartData(designId)
    }

    async registDesign( productData, isDraft, store ){
      const itemList = Array.from({ length: productData.quantity }, () => 1);

      // 未編集をカウントしていく
      for( const item of productData.canvasDatas[0].itemList.slice() ){
        for( let i=0; i<productData.quantity; ++i ){
          if( item.textArray[i] == "" ){
            itemList[i] = 0;
          }
        }
      }

      var editedNum = itemList.filter( item => item == 1 ).length;

      console.log("RegistDesign")
      console.log(productData)

      // const isAcryl = [ProductId.S, ProductId.M, ProductId.L].includes(productData.productId)
      // console.log(isAcryl)

      // ZIPデータの保存
      const zipData = productData.makeZipData();
      let zipBlob = await productData.makeZipBlob(zipData)
      await productData.uploadZipFile(zipBlob, FirebaseCommon.getZipFileName(productData.id))
      // const zipFilePath = await FirebaseCommon.getImageUrl(FirebaseCommon.getZipFileName(productData.id)).catch(() => {});

      // プレビュー用のデータを保存
      const designImage = store.state.designImageFile;
      await productData.uploadPngImageFile(designImage, FirebaseCommon.getDesignFileName(productData.id))
      const designFilePath = await FirebaseCommon.getImageUrl(FirebaseCommon.getDesignFileName(productData.id)).catch(() => {});

      let cutlineFilePath = "";
      if( productData.isShareCodeDraft ){
        await productData.uploadPngImageFile(store.state.scCutlineImageFile, FirebaseCommon.getPngCutlineFileName(productData.id), true)
        cutlineFilePath = await FirebaseCommon.getImageUrl(FirebaseCommon.getPngCutlineFileName(productData.id)).catch(() => {});
      }else{
        await productData.uploadSvgImageFile(store.state.cutlineImageFile, FirebaseCommon.getSvgCutlineFileName(productData.id))
        cutlineFilePath = await FirebaseCommon.getImageUrl(FirebaseCommon.getSvgCutlineFileName(productData.id)).catch(() => {});
      }

      // このデータはオプション品もあることを考慮すること
      const designData = {
        uid: firebase.auth().currentUser.uid,
        previewImagePath: designFilePath,
        cutlineImagePath: cutlineFilePath,
        designId: productData.id,
        isDraft: isDraft,
        productId: productData.productId,
        quantity: parseInt(productData.quantity),
        editedNum: editedNum,
        createDate: new Date(),
      }

      await this.addFBDesignData(designData);
    }

    async getFBDesignData(){
      const ref = firebase.firestore().collection("AcryProDraft");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).orderBy("createDate", "desc").get()

      this.draftList = []
      this.designHistory = []

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        const obj =
          {
            uid: data.uid,
            previewImagePath: data.previewImagePath,
            cutlineImagePath: data.cutlineImagePath,
            designId: data.designId,
            isDraft: data.isDraft,
            productId: data.productId,
            quantity: parseInt(data.quantity),
            editedNum: data.editedNum,
            createDate: data.createDate,
          };

          if( obj.isDraft ){
            this.draftList.push(obj);
            //Vue.set(this.draftList, this.draftList.length, obj);
          }else{
            this.designHistory.push(obj);
            //Vue.set(this.designHistory, this.designHistory.length, obj);
          }
      }
    }

    async addFBDesignData(data){
      await firebase.firestore().collection("AcryProDraft").add(data);
    }

    async deleteFBCartData( designId ){
      const ref = firebase.firestore().collection("AcryProDraft");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).where("designId", "==", designId).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProDraft").doc(doc.id).delete().then(() => {
          console.log("Document successfully deleted!");
          if( doc.data().isDraft ){
            const index = this.draftList.findIndex( item => item.designId == designId );
            this.draftList.splice(index, 1);
            //Vue.set(this.draftList);
          }else{
            const index = this.designHistory.findIndex( item => item.designId == designId );
            this.designHistory.splice(index, 1);
            //Vue.set(this.designHistory);
          }
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

    async allDeleteFBCartData(){
      const ref = firebase.firestore().collection("AcryProDraft");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProDraft").doc(doc.id).delete().then(() => {
          console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

}
export { DraftManager }